module.exports = __webpack_public_path__ + "static/media/coronaD.03cf51a7.png";